import React, { useState, useEffect, FunctionComponent } from 'react';
import { Presentation } from './presentation';
import type { CompanyDetailRecruitmentsChildProps as Props } from './types';
import type { CompanyRecruitmentDetail } from '../../../types/companyDetail';
import { getCompanyRecruitmentDetail } from '../../../services/companies';

export const Component: FunctionComponent<Props> = (props) => {
  const [detail, setDetail] = useState<CompanyRecruitmentDetail>({
    occupationNames: '',
    image: null,
    recruitmentTitle: '',
    release: '',
  });

  useEffect(() => {
    const fetchCompanyRecruitmentDetail = async () => {
      try {
        const response = await getCompanyRecruitmentDetail(props.id);
        setDetail({
          occupationNames: response.occupationNames ?? '',
          image: response.image ?? null,
          recruitmentTitle: response.recruitmentTitle ?? '',
          release: response.release ?? '',
        });
      } catch (error) {
        console.log(error);
      }
    };
    fetchCompanyRecruitmentDetail();
  }, [props.id]);

  return (
    <Presentation
      id={props.id}
      companyId={props.company.id}
      coverNoImg={props.coverNoImg}
      dataCategory={props.dataCategory}
      dataValue={props.dataValue}
      detail={detail}
    />
  );
};
